<template>
  <article :class="wrapClass">
    <div class="cursor cursor--small"></div>
    <canvas class="cursor cursor--canvas" resize></canvas>
    <Header :trigger="trigger"/>
    <div class="container about contact">
      <img :src="contact" class="contact__image">
      <section class="about__intro">
        <h1>contact us</h1>
        <p class="about__intro__label">business & client</p>
        <p class="about__text">desperate.</p>
        <p class="about__text">contact@desperate.dk</p>
        <p class="about__text">+45 4224 2116</p>
      </section>
      <section class="about__intro">
        <h1>location</h1>
        <p class="about__intro__label">address</p>
        <p class="about__text">store kirkestræde 3, 4. sal</p>
        <p class="about__text">1073 københavn k</p>
      </section>
    </div>
  </article>
</template>

<script>
import Header from '@/components/Header/Header';
import IntroBox from '@/components/IntroBox/IntroBox';
import Footer from '@/components/Footer/Footer';
import './style.scss';
import contact from '@/assets/contact.png';
import mouse from '@/utils/mouse';
import ismobile from '@/utils/ismobile';

export default {
  name: 'Contact',
  data() {
    return {
      wrapClass: 'wrap wrap--bottom-left',
      contact,
    };
  },
  components: {
    Header,
    IntroBox,
    Footer,
  },
  mounted() {
    !ismobile() && mouse();
    setTimeout(() => {
      this.wrapClass = 'wrap wrap--bottom-left loaded';
    }, 400);
  },
  methods: {
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/containers/Contact/Contact.vue